<template>
    <Header/>
    <div class="page">
        <router-view/>
    </div>
    <SessionTimeoutModal v-if="isLoggedIn" @logout="handleForcedLogout"/>
</template>

<script>

import {computed, onBeforeMount} from 'vue';
import {setParams} from "@/stores/params";
import {setApplication} from "@/stores/application";
import {logOut, setPendingActions, setUserData, userState} from "@/stores/user";
import Header from "@/layout/Header.vue";
import SessionTimeoutModal from "@/components/SessionTimeoutModal";
import {setReturnUrl} from "./stores/application";

export default {
    name: 'App',
    components: {
        SessionTimeoutModal,
        Header,
    },
    props: {
        options: Object
    },
    setup(props) {
        onBeforeMount(() => {
            setUserData(props.options.user);
            setApplication(props.options.application);
            setReturnUrl(props.options.returnUrl);
            setPendingActions(props.options.pendingActions);
            setParams(props.options.params);
        });

        const handleForcedLogout = () => {
            logOut();
        };

        return {
            isLoggedIn: computed(() => userState.isLoggedIn),
            handleForcedLogout
        };
    }
}
</script>

<style>
div.page {
    margin-top: 60px;
}

.toggle-password-eye {
    float: right;
    top: -25px;
    right: 10px;
    position: relative;
    cursor: pointer;
}
</style>
